<div class="container p-5">
  <div id="header" class="d-flex flex-col justify-content-between mx-auto">
    <h1 style="display: inline" class="mr-auto">Subscribers</h1>
    <div>
      <button type="button" class="btn btn-primary" (click)="copyAllEmails()">
        Copy All Emails <fa-icon [icon]="faFileImport"></fa-icon>
      </button>
      <button type="button" class="btn btn-primary" (click)="exportToCsv()">
        Download All Emails <fa-icon [icon]="faDownload"></fa-icon>
      </button>
      <button type="button" class="btn btn-primary" (click)="handleSubscribers({ col: { label: tableActions.Add } })">
        Add New Subscriber <fa-icon [icon]="faPlus"></fa-icon>
      </button>
    </div>
  </div>
  <app-subscriber-table (iconClick)="handleSubscribers($any($event))"></app-subscriber-table>
  <span class="d-flex flex-col justify-content-end" style="font-weight: bold">
    Total Subscribers: {{ totalSubscribers.toLocaleString() }}
  </span>
</div>